module.exports = __webpack_public_path__ + "img/Mathematics.506b8ff9.svg";